export const authHost = process.env.NODE_ENV === 'development' ? 'http://localedtechimpact.com:3000' : 'https://edtechimpact.com';

export const getCsrfToken = async () => {
  const csrfResponse = await fetch(`${authHost}/api/auth/csrf/`, {credentials: 'include'})
  const { csrfToken } = await csrfResponse.json()
  return csrfToken
}